import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IPublicUser } from '@/types'
import { FollowerCard } from '@components-v2/molecules/FollowerCard'
import { NoContent } from '@components-v2/atoms/NoContent'
import { ProfileCardListGrid } from '@components-v2/organisms/ProfileCardListGrid'

type Props = {
  items: IPublicUser[]
}

export const ProfileFollowers: FC<Props> = observer(({ items = [] }) => {
  const { t } = useTranslation(['p'])
  if (items.length === 0) {
    return <NoContent>{t('フォロワーはまだいません。')}</NoContent>
  }

  return (
    <ProfileCardListGrid>
      {items.map((item) => (
        <FollowerCard key={item.username} user={item} />
      ))}
    </ProfileCardListGrid>
  )
})
